module.exports = {
    '--sm-viewport': '(max-width: 425.9px)',
    '--md-viewport': '(min-width: 426px)'
}


// WEBPACK FOOTER //
// ./src/constants/mediaqueries.js